"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyToString = exports.getFormattedAmountByCurrency = exports.transformToCurrency = exports.getCurrencySymbol = exports.getCurrencyPlaceholder = void 0;
/*
    Hacky ways (but vanilla JS) of pulling the currency information given a currency code.

    The native version of the JS `Intl` library doesn't provide a straightforward way for
    obtaining just the currency symbol. Alternatively we could pull in a 3rd party library to do this.
*/
const defaultTo_1 = __importDefault(require("lodash/defaultTo"));
const cssxp_ccp_types_1 = require("@atlassian/cssxp-ccp-types");
const getCurrencyPlaceholder = (currency) => {
    const charactersInCurrencyCode = 3;
    return (new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency ? currency : 'USD',
        currencyDisplay: 'code',
    })
        .format(0)
        // Remove the currency code based on number of digits present
        .substring(charactersInCurrencyCode)
        .trim());
};
exports.getCurrencyPlaceholder = getCurrencyPlaceholder;
const getCurrencySymbol = (currency) => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency ? currency : 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    return formatter.format(0).replace(/\d+/, '');
};
exports.getCurrencySymbol = getCurrencySymbol;
const countDecimalPlaces = (value) => {
    const splitByDecimal = value.split('.');
    return splitByDecimal.length > 1 ? splitByDecimal[1].length : 0;
};
const transformToCurrency = (currentValue, currency) => {
    const convertedInput = Number(currentValue);
    if (currentValue && !Number.isNaN(convertedInput)) {
        // if a number and there is a period, return it (avoids )
        if (currentValue.slice(-1) === '.') {
            return currentValue;
        }
        // TODO - use NumberFormat.formatToParts when better supported
        const valueAsCurrency = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency ? currency : 'USD',
            currencyDisplay: 'code',
        }).format(convertedInput);
        const decimalPlacesForCurrency = countDecimalPlaces(valueAsCurrency);
        const decimalPlacesForInput = countDecimalPlaces(currentValue);
        // If a user types in 1.1, don't add the additional padding for USD to be 1.10
        const numberOfDecimalForOutput = Math.min(decimalPlacesForCurrency, decimalPlacesForInput);
        return `${Number(currentValue).toFixed(numberOfDecimalForOutput)}`;
    }
    else {
        return currentValue;
    }
};
exports.transformToCurrency = transformToCurrency;
const currencyDecimalFormatter = {
    JPY: 1,
    USD: 100,
};
const getFormattedAmountByCurrency = (amount, currency) => {
    currency = currency || cssxp_ccp_types_1.Currency.USD;
    return transformToCurrency(((0, defaultTo_1.default)(amount, 0) / currencyDecimalFormatter[currency]).toString(), currency);
};
exports.getFormattedAmountByCurrency = getFormattedAmountByCurrency;
const currencyToString = (price, currency) => {
    if (currency) {
        return getFormattedAmountByCurrency(price, currency);
    }
    return ((0, defaultTo_1.default)(price, 0) / 100).toFixed(2);
};
exports.currencyToString = currencyToString;
